import { DynamicStyleSheet, variants } from '@pulsar/core';

export default DynamicStyleSheet.create(theme => ({
  root: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    ...variants({
      primary: {
        height: 44,
      },
      secondary: {
        height: 40,
      },
    }),
  },
  main: {
    flexDirection: 'row',
    alignItems: 'baseline',
  },
  indicator: {
    marginLeft: 6,
    flexShrink: 0,
  },
  indicatorText: {
    color: theme.colors.textSecondary,
  },
  text: {
    ...variants({
      secondary: {
        color: theme.colors.textSecondary,
      },
    }),
  },
  subtitle: {
    color: theme.colors.textSecondary,
  },
}));
